module.exports = __webpack_public_path__ + "img/student-brief (2).6820cda8.png";